import {Component, EventEmitter, OnInit} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-sprint-confirmationdialog',
  templateUrl: './delete-sprint-confirmationdialog.component.html',
  styleUrls: ['./delete-sprint-confirmationdialog.component.scss']
  })
export class DeleteSprintConfirmationdialogComponent implements OnInit {
  onDeleteConfirmation = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<DeleteSprintConfirmationdialogComponent>,
    public deleteConfirmationDialog: MatDialog
  ) { }

  ngOnInit() {
  }

  closeDeleteConfirmationDialog() {
    this.dialogRef.close();

  }

  confirmDeleteSprint() {
    this.onDeleteConfirmation.emit(true);
    this.deleteConfirmationDialog.closeAll();
  }
}
